import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { useOnboarding } from '@/pages/Onboarding/context';
import { elevatorCloseSceneChoices } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/choicePanelOptions';
import { GenericScreenLayout } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/GenericScreenLayout';

export const ElevatorCloseScreen: React.FC = () => {
  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <GenericScreenLayout
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/elevator-close-scene.png`}
      title="Door clicks shut."
      choices={elevatorCloseSceneChoices.map((option) => ({
        ...option,
        onClick: handleNextStep,
      }))}
    />
  );
};
